import { cookieUtils } from '@albacross/frontend-utils'

import { CUSTOMER_COOKIE } from 'constants/app-constants'

const cookies = cookieUtils(__DOMAIN__, CUSTOMER_COOKIE)

export const deleteCustomerCookie = () => {
  cookies.deleteCookie(CUSTOMER_COOKIE)
}

export function createCookie(name, value, days?: any) {
  cookies.createCookie(name, value, days)
}

export const getCookie = name => cookies.getCookie(name)

export function deleteCookie(name) {
  cookies.deleteCookie(name)
}

export function deleteAllCookies() {
  cookies.deleteAllCookies()
}
